import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_BUSINESS_NOTES: (businessId, notes) => ({ businessId, notes }),
    API: {
      UPDATE_BUSINESS_NOTES: apiResourceActionCreator('business/notes')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/business/notes`, authToken, payload, actions.admin.api.updateBusinessNotes);

function* updateBusinessNotes(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'updateBusinessNotes',
  action: actions,
  sagas: updateBusinessNotes,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdatingBusinessNotes: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isUpdatingBusinessNotes: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isUpdatingBusinessNotes: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateBusinessNotes.js